import Swiper, { Navigation } from 'swiper';
Swiper.use(Navigation);
import 'swiper/swiper-bundle.css';

export const SwiperContainer = {
  smtBreakpoint:{
    slidesPerView: 1,
    spaceBetween: 0
  },
  speed:1000,
  grabCursor: true,
  centeredSlides:true,
  init:()=>{
    new Swiper('.lineup-container', {
      breakpoints:{
        // when window width is >= 320px
        0: SwiperContainer.smtBreakpoint,
        // when window width is >= 640px
        768: {
          slidesPerView: 3.8,
          spaceBetween: 80
        }
      },
      spaceBetween:80,
      speed:SwiperContainer.speed,
      centeredSlides: SwiperContainer.centeredSlides,
      grabCursor: SwiperContainer.grabCursor,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },
  galleryCarousel:()=>{
    new Swiper('.gallery-container', {
      breakpoints:{
        // when window width is >= 320px
        0: SwiperContainer.smtBreakpoint,
        // when window width is >= 640px
        768: {
          slidesPerView: 2.5,
          spaceBetween: 170
        }
      },
      loop:true.valueOf,
      speed:SwiperContainer.speed,
      centeredSlides: SwiperContainer.centeredSlides,
      grabCursor: SwiperContainer.grabCursor,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },
  // productKeyVisual:()=>{
  //   new Swiper('.productKv-containerInner', {
  //     loop:true.valueOf,
  //     // slidesPerView: '1', // スライド表示数
  //     // loop: true,
  //     // autoplay: {
  //     //   delay: 3000,
  //     // },
  //     // speed: 1000,
  //     // effect: 'fade',
  //     fadeEffect: {
  //       crossFade: true
  //     },

  //   })
  // }
};
